import { render, staticRenderFns } from "./VideoExpert.vue?vue&type=template&id=8bd2f304&scoped=true"
import script from "./VideoExpert.vue?vue&type=script&lang=js"
export * from "./VideoExpert.vue?vue&type=script&lang=js"
import style0 from "./VideoExpert.vue?vue&type=style&index=0&id=8bd2f304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd2f304",
  null
  
)

export default component.exports